import { envelopeRowHeadings } from "utils/upgrades";

/** Internal phase keys from `makeAuditError` / thunks → plain-language “where it failed”. */
const PHASE_WHERE = {
    hpxmlEnclosureExtract: "reading walls, roofs, and other surfaces from the HPXML file",
    hpxmlSystemsExtract: "reading heating, cooling, ventilation, and water heating from the HPXML file",
    hpxmlAuditMerge: "putting the comparison together",
    voltaEnvelope: "reading envelope data from your model",
    voltaSystems: "reading mechanical systems from your model",
    unknown: "running the comparison",
};

const envelopeRowLabelById = envelopeRowHeadings.reduce((acc, row) => {
    acc[row.id] = row.content;
    return acc;
}, {});

/**
 * User-facing copy for a structured audit error (technical fields stay out of the main paragraph).
 * @param {{ phase?: string, rowId?: string, message?: string, stack?: string, causeMessage?: string, causeStack?: string } | null} detail
 */
export function getAuditErrorUserCopy(detail) {
    if (!detail) return null;

    const where = PHASE_WHERE[detail.phase] || PHASE_WHERE.unknown;
    const rowName = detail.rowId ? envelopeRowLabelById[detail.rowId] || detail.rowId : null;
    const rowSentence = rowName ? ` This happened while handling the “${rowName}” row.` : "";

    return {
        title: "We couldn't finish the comparison",
        lead: `Something went wrong while ${where}.${rowSentence}`,
        closing: "You can try exporting the HPXML file to review the translation outside Volta SNAP.",
        technicalSummary: detail.message,
        stack: detail.stack,
        causeMessage: detail.causeMessage,
        causeStack: detail.causeStack,
    };
}

export function formatHpxmlParseErrorForUser(raw) {
    if (raw == null || raw === "") return "The HPXML content could not be read.";
    const t = String(raw).trim();
    if (/parsererror|not well-formed|mismatched tag|xml parsing/i.test(t)) {
        return "The file doesn't look like valid XML, so it couldn't be opened here. Try running EnergyPlus again, or open the downloaded HPXML in an editor to confirm it saved correctly.";
    }
    return "The HPXML file couldn't be read. Try exporting the HPXML to inspect it outside Volta SNAP.";
}

/**
 * Friendly message when fetching HPXML by URL fails (drawer open path).
 */
export function formatAuditFetchError(err) {
    if (!err) return "The HPXML file couldn't be loaded.";
    const msg = err.message || "";
    const name = err.name || "";
    if (name === "TypeError" || /failed to fetch|networkerror|load failed/i.test(msg)) {
        return "We couldn't download the HPXML file. Check your connection and try again.";
    }
    if (/abort/i.test(msg)) return "Loading the HPXML file was cancelled.";
    return "The HPXML file couldn't be loaded for the comparison. Please try again.";
}
